import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AlertsService {
  // constructor() {}

  bindNotificationOptions(
    notification: boolean,
    frequency: Array<string>,
    notificationOptions,
  ) {
    if (frequency && frequency.length) {
      frequency.forEach((data) => {
        notificationOptions[data] = true;
      });
    } else {
      // by default if alert is not set true
      notificationOptions.daily = true;
    }

    // by default if alert is not set true
    notificationOptions.systemAlert = notification === false ? false : true;
  }

  onEPChanges(allEventTypes, alertsDataToSend, eventFrom?: string) {
    const checkKey =
      eventFrom === "watchlist" ? "default_check_in_watchlist" : "checked";
    const earningsPreviewObj = allEventTypes.filter(function (val) {
      return val.display_name === "Earnings Preview";
    })[0];

    const selectedVal = earningsPreviewObj.subcategories.filter(function (sub) {
      return sub[checkKey] === true;
    });

    for (let i = 0; i < earningsPreviewObj.subcategories.length; i++) {
      const name = earningsPreviewObj.subcategories[i].name;
      const checked = earningsPreviewObj.subcategories[i][checkKey];
      if (
        checked === true &&
        alertsDataToSend.alert_event_types.indexOf(name) === -1
      ) {
        alertsDataToSend.alert_event_types.push(name);
      } else if (
        checked === false &&
        alertsDataToSend.alert_event_types.indexOf(name) > -1
      ) {
        alertsDataToSend.alert_event_types.splice(
          alertsDataToSend.alert_event_types.indexOf(name),
          1,
        );
      }
    }

    if (selectedVal.length > 0) {
      earningsPreviewObj[checkKey] = true;
    } else {
      earningsPreviewObj[checkKey] = false;
    }
  }

  onClickEventType(
    params,
    disabledBrokers: boolean,
    allEventTypes,
    alertsDataToSend,
    brokerList,
    eventFrom?: string,
  ) {
    const checkKey =
      eventFrom === "watchlist" ? "default_check_in_watchlist" : "checked";
    if (eventFrom !== "watchlist") {
      params[checkKey] = params[checkKey] ? false : true;
    }
    let selectedCount = null;
    switch (params.display_name) {
      case "New Model": {
        if (params[checkKey]) {
          disabledBrokers = false;
          alertsDataToSend.alert_event_types.push(params.name);
          const brokerNameKey =
            eventFrom === "watchlist" ? "label" : "broker_name";
          brokerList.map((broker) => {
            broker.checked = true;
            return broker[brokerNameKey];
          });
          selectedCount = brokerList.length;
        } else {
          disabledBrokers = true;
          if (alertsDataToSend.alert_event_types.indexOf(params.name) > -1) {
            alertsDataToSend.alert_event_types.splice(
              alertsDataToSend.alert_event_types.indexOf(params.name),
              1,
            );
          }
        }
        break;
      }
      case "Earnings Preview": {
        const earningsPreviewObj = allEventTypes.filter(function (val) {
          return val.display_name === "Earnings Preview";
        })[0];

        if (params[checkKey]) {
          earningsPreviewObj.subcategories.map(function (sub) {
            alertsDataToSend.alert_event_types.push(sub.name);
            return (sub[checkKey] = true);
          });
        } else {
          earningsPreviewObj.subcategories.map(function (sub) {
            if (alertsDataToSend.alert_event_types.indexOf(sub.name) > -1) {
              alertsDataToSend.alert_event_types.splice(
                alertsDataToSend.alert_event_types.indexOf(sub.name),
                1,
              );
            }
            return (sub[checkKey] = false);
          });
        }
        break;
      }
      default: {
        if (params[checkKey]) {
          if (alertsDataToSend.alert_event_types.indexOf(params.name) === -1) {
            alertsDataToSend.alert_event_types.push(params.name);
          }
        } else {
          if (alertsDataToSend.alert_event_types.indexOf(params.name) > -1) {
            alertsDataToSend.alert_event_types.splice(
              alertsDataToSend.alert_event_types.indexOf(params.name),
              1,
            );
          }
        }
      }
    }

    return {
      disabledBrokers: disabledBrokers,
      selectedCount: selectedCount,
    };
  }

  onBrokerChanges(
    brokerList,
    onBrokerChanges?: boolean,
    allEntitledBrokers?: boolean,
    eventFrom?: string,
  ) {
    let disabledBrokers = false;
    const selectedBrokers = brokerList.filter(function (broker) {
      return broker.checked === true;
    });
    if (selectedBrokers.length === 0 || !onBrokerChanges) {
      disabledBrokers = true;
    } else {
      disabledBrokers = false;
    }
    if (
      allEntitledBrokers !== undefined &&
      brokerList.length === selectedBrokers.length
    ) {
      allEntitledBrokers = true;
    } else {
      allEntitledBrokers = false;
    }
    const brokerNameKey = eventFrom === "watchlist" ? "label" : "broker_name";
    return {
      selectedBrokers: selectedBrokers.map((x) => x[brokerNameKey]),
      disabledBrokers: disabledBrokers,
      allEntitledBrokers: allEntitledBrokers,
    };
  }
}
